import React, { Component } from 'react';

export default class Footer extends Component{
  render(){
    return(
      <div className="container-fluid" id="footer">
        <div className="col-sm-12">
          <div className="row">
            <p className="text-center">Developed by Karl-Edward F P Jean-Mehu</p>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/Footer.js